import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=13803bf3&scoped=true&"
import script from "./Impressum.vue?vue&type=script&lang=ts&"
export * from "./Impressum.vue?vue&type=script&lang=ts&"
import style0 from "./Impressum.vue?vue&type=style&index=0&id=13803bf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13803bf3",
  null
  
)

export default component.exports